"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMilliseconds = exports.getHundredthsOfSecond = exports.getTenthsOfSecond = void 0;
var pad_number_to_length_1 = require("../utils/pad-number-to-length");
/**
 * Returns a numerical representation of the 1/10 of second: 0, 1, ..., 9
 * @hidden
 */
var getTenthsOfSecond = function (_a) {
    var date = _a.date;
    return Math.floor(date.getMilliseconds() / 100);
};
exports.getTenthsOfSecond = getTenthsOfSecond;
/**
 * Returns a two-digit string representation of the 1/100 of second: 00, 01, ..., 99
 * @hidden
 */
var getHundredthsOfSecond = function (_a) {
    var date = _a.date;
    return pad_number_to_length_1.padNumberToLength(Math.floor(date.getMilliseconds() / 10), 2);
};
exports.getHundredthsOfSecond = getHundredthsOfSecond;
/**
 * Returns a three-digit string representation of the milliseconds: 000, 001, ..., 999
 * @hidden
 */
var getMilliseconds = function (_a) {
    var date = _a.date;
    return pad_number_to_length_1.padNumberToLength(date.getMilliseconds(), 3);
};
exports.getMilliseconds = getMilliseconds;
//# sourceMappingURL=fractional-seconds.js.map